import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { firstValueFrom, Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { RecruitService } from '../@shared/services/recruitment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../environments/environment';
import Swal from 'sweetalert2';
import { ConfigurationalmasterService } from '../@shared/services/configurationalmaster.service';
import { CommonService } from '../@shared/services/common.service';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { ViewDocumentDialogComponent } from './view-document-dialog/view-document-dialog.component';
import { ExternaljobapplyComponent } from '../@auth/popup-manpower/externaljobapply/externaljobapply.component';
import { SharedUtilityService } from '../@shared/services/sharedUtility/shared-utility.service';
import { EncryptionService } from 'src/app/@shared/services/encryptionService/encryption.service';
@Component({
  standalone: false,
  selector: 'app-candidate-form',
  templateUrl: './candidate-form.component.html',
  styleUrls: ['./candidate-form.component.scss'],
})
export class CandidateFormComponent {
  jobDetailsForm: any;
  designationList: any;
  jdId: any;
  imagePath: any;
  imageToUpload: any;
  baseUrl: any;
  startDate: any;
  endDate: any;
  check: any;

  tableData = [
    { sno: 1, question: 'What is your name?', answer: 'My name is John.' },
    {
      sno: 2,
      question: 'Where do you live?',
      answer: 'I live in New York City.',
    },
    // Add more objects as needed
  ];
  allJobArray: any;
  jobDataBy: any;
  idGet: any;
  finalQuestionData: any;
  CvUploaded: any;
  fileUpload: any;
  openUserForm: boolean = false;
  result: any;
  manpowerStatus: any;
  constructor(
    private toast: ToastrService,
    public dialog: MatDialog,
    private recruitService: RecruitService,
    private activeroute: ActivatedRoute,
    private _configurationalMasterService: ConfigurationalmasterService,
    private $common: CommonService,
    private route: Router,
    private sharedUtility: SharedUtilityService,
    private crypto: EncryptionService
  ) {
    this.myForm = new FormGroup({
      location: new FormControl(''),
      job_title: new FormControl(''),
      position: new FormControl(null),
      end_date: new FormControl(null),
      file: new FormControl(null),
      department: new FormControl(null),
      area: new FormControl(null),
      exp_required: new FormControl(null),
      level_of_interview: new FormControl(null),
      qualification: new FormControl(null),
      skill: new FormControl(null),
      first_name: new FormControl(null, [Validators.required]),
      middle_name: new FormControl(null),
      last_name: new FormControl(null, [Validators.required]),
      contact_number: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^[0-9]{5,15}$/),
      ]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      cv_upload: new FormControl(null, [Validators.required]),
      address: new FormControl(null, [Validators.required]),
      pincode: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^[0-9]{6}$/),
      ]),
      question_answer_user: new FormControl(null),
      country_code: new FormControl(null, [Validators.required]),
    });
  }

  expirationDate: Date;
  currentDate: Date = new Date();
  linkExpired: boolean = false;

  ngOnInit() {
    this.baseUrl = environment?.servralUrl;
    this.activeroute.params.subscribe((params: any) => {

      const paramsid = this.crypto.decryptObject(params['id']);

      

      this.jdId = Number(paramsid);

      this.getByJD();
    });
    //     this.recruitService.currentMessage.subscribe((res:any) =>{
    // 

    //     })
    this.getAll_Country_codes();
  }

  reference_number: any;
  no_of_position: any;
  company_Branch :any ;
  getByJD() {
    let entity_id = localStorage.getItem('selectedEntityId');
    let financial_id = localStorage.getItem('financial_id');
    let user_id = localStorage.getItem('EmpMainId');

    this.recruitService.getByJobDescription(this.jdId).subscribe((res: any) => {
      this.allJobArray = res;

      this.jobDataBy = res?.data[0];
      this.manpowerStatus = res?.data[0]?.manpower_status;
      this.reference_number = this.jobDataBy?.jd_number;
      this.no_of_position = this.jobDataBy?.designation_name;
      this.company_Branch = this.jobDataBy?.company_branch;

      const statusUpper = String(this.manpowerStatus || '').toUpperCase();
      if (this.manpowerStatus != null && statusUpper === 'CLOSE') {
        this.linkExpired = true;
        this.showLinkExpiredPopup();
      } else {
        this.linkExpired = false;
        this.patchFormValue();
        this.dateExpire();
        this.checkDateRange();
      }
    });
  }

  showLinkExpiredPopup(): void {
    Swal.fire({
      title: 'Link Expired',
      html: 'This job application link is no longer active. The position may have been closed or the link has expired.',
      icon: 'info',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      buttonsStyling: false,
      customClass: {
        popup: 'holiday-delete-popup',
        confirmButton: 'holiday-delete-confirm-btn',
      },
    });
  }

  /** Re-verify manpower status via API; if not OPEN, show dialog and return. If OPEN, call next(). */
  verifyManpowerStatus(next: () => void): void {
    this.recruitService.getByJobDescription(this.jdId).subscribe((res: any) => {
      const status = res?.data?.[0]?.manpower_status;
      const statusUpper = String(status ?? '').toUpperCase();
      if (statusUpper === 'CLOSE') {
        this.manpowerStatus = status;
        this.linkExpired = true;
        this.showLinkExpiredPopup();
        return;
      }
      next();
    });
  }

  onSaveClick($event?: Event): void {
    $event?.preventDefault();
    this.verifyManpowerStatus(() => {
      const obs = this.saveQuestion();
      if (obs) obs.subscribe();
    });
  }

  onSubmitClick($event?: Event): void {
    $event?.preventDefault();
    this.verifyManpowerStatus(() => this.ngSubmit());
  }

  /** Single Submit: validate first, then confirm, then run save then submit (no popup if validation fails). */
  onConfirmSubmitClick($event?: Event): void {
    $event?.preventDefault();
    if (this.check !== true) {
      return;
    }
    this.myForm?.markAllAsTouched();
    if (this.myForm?.invalid) {
      this.toast.error('Required fields should not be empty', 'Fields Error');
      return;
    }
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to save and submit your application?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      buttonsStyling: false,
      customClass: {
        popup: 'holiday-delete-popup',
        confirmButton: 'holiday-delete-confirm-btn',
        cancelButton: 'holiday-delete-cancel-btn',
      },
    }).then((result) => {
      if (!result.isConfirmed) return;
      this.verifyManpowerStatus(() => this.runSaveThenSubmit());
    });
  }

  private async runSaveThenSubmit(): Promise<void> {
    const obs = this.saveQuestion();
    if (!obs) return;
    try {
      await firstValueFrom(obs);
      this.ngSubmit();
    } catch (err) {
      // saveQuestion already shows toast on error
    }
  }

  patchFormValue() {
    this.myForm.patchValue({
      job_title: this.jobDataBy?.job_title,
      jobTypeId: this.jobDataBy?.jobTypeId,
      end_date: this.jobDataBy?.end_date,
      qualification: this.jobDataBy?.qualification,
      skill: this.jobDataBy?.skill,
      position: this.jobDataBy?.designation_name,
      department: this.jobDataBy?.department_name,
      location: this.jobDataBy?.branch_name,
      area: this.jobDataBy?.area_name,
      level_of_interview: this.jobDataBy?.level_of_interview,
      exp_required: this.jobDataBy?.experience,
      country_code: this.jobDataBy?.country_code,
    });

  }
  hasError: null;
  myForm: FormGroup;

  selectedFileName: string = 'No file chosen';
  downloadJD() { }
  onChange(e: any) {
    if (e.target.files && e.target.files[0]) {
      const data: FileList = e.target.files;
      this.imageToUpload = data.item(0) || null;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePath = e.target.result;
      };
      reader.readAsDataURL(this.imageToUpload);
    }
    
    let formData = new FormData();

    formData.append('file', this.imageToUpload);

    this.recruitService.documentsUpdate(formData).subscribe((res: any) => {
      
      this.fileUpload = res?.url;
    });
  }

  isTodayBetweenDates(): boolean {
    const today = new Date().setHours(0, 0, 0, 0);
    return (
      today >= new Date(this.jobDataBy.start_date).setHours(0, 0, 0, 0) &&
      today <= new Date(this.jobDataBy.end_date).setHours(23, 59, 59, 999)
    );
  }

  removeSpaces(event: any) {
    const trimmed = event.target.value.replace(/^\s+/, '');
    if (event.target.value !== trimmed) {
      event.target.value = trimmed;
      event.target.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  onChangeCv(e: any) {
    let isValidExtension = this.$common.checkForValidFile(
      e,
      true,
      false,
      false
    );
    if (!isValidExtension) {
      this.myForm.patchValue({ cv_upload: null });
      return;
    }

    if (e.target.files && e.target.files[0]) {
      const data: FileList = e.target.files;
      this.imageToUpload = data.item(0) || null;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePath = e.target.result;
      };
      reader.readAsDataURL(this.imageToUpload);
    }
    
    let formData = new FormData();

    formData.append('file', this.imageToUpload);

    this.recruitService.documentsUpdate(formData).subscribe((res: any) => {
      
      this.CvUploaded = 'uploaded_files/' + res?.url;
    });
  }
  getAnswer(data: any, event: any) {
    
    

    this.allJobArray?.getAllData_question.forEach((item: any) => {
      if (data?.id === item?.id) {
        item.selection_answer = event.value;
        item.hasAnswerError = false;

        // Reset customAnswer if not 'Other'
        if (event.value !== 'Other') {
          item.customAnswer = null;
        }
      }
    });

    
    this.finalQuestionData = this.allJobArray?.getAllData_question;
  }

  dateExpire() {
    this.startDate = new Date(this.jobDataBy?.start_date);
    this.endDate = new Date(this.jobDataBy?.end_date);
    this.currentDate = new Date();

    this.endDate.setHours(23, 59, 59, 999);
    let startTimestamp = this.startDate.getTime();
    let endTimestamp = this.endDate.getTime();
    let currentTimestamp = this.currentDate.getTime();

    this.check =
      currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp;
    return this.check;
  }

  checkDateRange() {
    if (this.check == false) {
      this.myForm.disable({ emitEvent: false });
      Swal.fire({
        title: `Your Job Description link has expired. Applications were accepted only between ${moment(this.startDate).format('DD-MM-YYYY')} and ${moment(this.endDate).format('DD-MM-YYYY')}.`,
        icon: 'warning',
        showConfirmButton: false,
        allowOutsideClick: false,
        customClass: {
          popup: 'holiday-delete-popup',
        },
      }).then((result) => { });
    }
  }

  generateImageUrl() {
    return `${this.baseUrl}/`;
  }
  submitForm() {
    let selectedEntityId = localStorage.getItem('selectedEntityId');

    let query = {
      entityId: selectedEntityId,
      jd_id: this.jd_id,
    };
    this.recruitService.createUserData(query).subscribe(
      (res: any) => {
        
        this.toast.success(`Submitted Successfully`);
        this.route.navigateByUrl('/auth/pop-up-manpower/external-job-apply');
      },
      (err: any) => {
        
        this.toast.error(`Please Try Again`);
      }
    );
  }

  ngSubmit() {
    this.myForm?.markAllAsTouched();
    if (this.myForm?.invalid) {
      this.toast.error('Required fields should not be empty', 'Fields Error');
      return;
    }
    this.submitForm();
    if (this.result == 'SELECTED') {
      Swal.fire({
        title: `Submission successful! HR will contact you for the next round.`,
        icon: 'success',
        confirmButtonText: 'OK',
        buttonsStyling: false,
        customClass: {
          popup: 'holiday-delete-popup',
          confirmButton: 'holiday-delete-confirm-btn',
        },
      }).then((result) => {
        if (result) {
          location.reload();
        }
      });
    } else {
      Swal.fire({
        title: `Thank You, Our team will reach you`,
        icon: 'info',
        confirmButtonText: 'OK',
        buttonsStyling: false,
        customClass: {
          popup: 'holiday-delete-popup',
          confirmButton: 'holiday-delete-confirm-btn',
        },
      }).then((result) => {
        if (result) {
          location.reload();
        }
      });
    }
  }

  jd_id: any;
  isDisabled: boolean = true;
  saveQuestion(): Observable<any> | void {
    this.myForm?.markAllAsTouched();
    const questionList = this.finalQuestionData || this.allJobArray?.getAllData_question || [];
    questionList.forEach((item: any) => {
      item.hasError = false;
      item.hasAnswerError = false;
    });

    Object.keys(this.myForm.controls).forEach(key => {
      const control = this.myForm.get(key);
      if (
        typeof control?.value === 'string' &&
        key !== 'cv_upload'
      ) {
        control.setValue(control.value.trim());
      }
    });

    if (this.myForm?.invalid) {
      this.toast.error(
        'Required fields should not be empty',
        'Fields Error'
      );
      return;
    }

    const hasUnanswered = questionList.some((item: any) => !item.selection_answer);
    if (hasUnanswered) {
      questionList.forEach((item: any) => {
        if (!item.selection_answer) item.hasAnswerError = true;
      });
      this.toast.error('Please answer all questions.');
      return;
    }

    for (const item of this.finalQuestionData || []) {
      item.customAnswer = item.customAnswer?.trim();
      if (
        item.selection_answer === 'Other' &&
        (!item.customAnswer || item.customAnswer.trim() === '')
      ) {
        item.hasError = true;
        this.toast.error(
          'Please specify your answer for the "Other" option.'
        );
        return;
      }
    }

    let value = this.myForm?.value;
    const modify: any = [];
    this.finalQuestionData?.map((item: any) => {
      modify.push({
        question_id: item?.id,
        selection_answer: item?.selection_answer,
        custom_answer:
          item?.selection_answer === 'Other' ? item?.customAnswer : null,
      });
    });
    if (!this.finalQuestionData?.length) {
      this.toast.error(
        'Required fields should not be empty',
        'Fields Error'
      );
      return;
    }
    let data = {
      item: modify,

      first_name: value?.first_name,
      middle_name: value?.middle_name,
      last_name: value?.last_name,
      contact_number: value?.contact_number,
      email: value?.email,
      cv_upload: this.CvUploaded,
      address: value?.address,
      pincode: value?.pincode,
      country_code: value.country_code,
      approved_by: this.sharedUtility.getUpdatedByField()
    };

    return this.recruitService.submitUserQuestion(this.jdId, data).pipe(
      tap((res: any) => {
        this.result = res?.result;
        this.jd_id = res?.jd_id;
        this.toast.success(`Questions Submitted Successfully`);
        this.isDisabled = false;
      }),
      catchError((err: any) => {
        this.toast.error(err?.error?.message ?? 'Something went wrong');
        throw err;
      })
    );
  }
  countryCodeList: any = [];

  filteredCountryCodeList1: any = [];
  filteredCountryCodeList2: any = [];
  getAll_Country_codes() {
    this._configurationalMasterService
      .getAll_Country_codes()
      .subscribe((res: any) => {
        this.countryCodeList = res.data;
        this.filteredCountryCodeList1 = [...this.countryCodeList];
        this.filteredCountryCodeList2 = [...this.countryCodeList];
      });
  }

  filterCountryCode2(event: any) {
    const searchValue = event?.target?.value?.toLowerCase() || '';
    if (!searchValue) {
      this.filteredCountryCodeList2 = [...this.countryCodeList];
      return;
    }
    this.filteredCountryCodeList2 = this.countryCodeList.filter((item: any) =>
      item.dialing_code?.toLowerCase().includes(searchValue)
    );
  }

  openDialog() {
    const dialogRef = this.dialog.open(ViewDocumentDialogComponent, {
      data: { descripition: this.jobDataBy?.descripition },

      width: '80%',
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  onAnswerChange(item: any, selectedValue: string) {
    item.selection_answer = selectedValue;
    if (selectedValue !== 'Other') {
      item.customAnswer = null;
    }
  }

  onCustomAnswerChange(item: any, value: string) {
    item.customAnswer = value;
    if (value?.trim()) {
      item.hasError = false;
    }
  }
}
